/**
 * BIES Bundle Map - Shared mapping of bundle tiers
 * Used by both bies-volume-selector.js (product page) and bies-cart-drawer.js (cart)
 *
 * Commercial policy (Jaime, call 22-sep-2026, design B of
 * clients/bies/docs/plans/2026-09-commercial-policy-matrix.md):
 *   1 unit = full price · 2 units = -10 % · 3 or more units = -15 %, no cap.
 *
 * Catalog today (Shopify variants, each one a separate product with its own price):
 *   Tier 1: Individual product (original variant)
 *   Tier 2: Bundle 2x (-10 %)
 *   Tier 3: Bundle 3x (-15 %)
 *   Tier 4: Bundle 4x (-15 % in the publishable preview; reprice on DAY D)
 *   Tier 5: Bundle 5x (-15 %, prepared but unlinked until DAY D)
 *
 * With 3x, 4x and 5x all at -15 %, every quantity of 3 or more is made of
 * packs only (6 = 3+3, 7 = 4+3, 8 = 4+4, 11 = 5+3+3…), so the cart never
 * needs a single unit. That matters for products whose single unit runs out
 * with "don't sell without stock" (the granolas, 1-oct): a single unit in
 * the composition made Shopify reject the whole add.
 *
 * The cart composes any number of units from the pack variants that exist
 * (BIES_COMPOSE_UNITS). It never composes a cart that charges MORE than the
 * policy price the product page shows: when the catalog cannot hit -15 %
 * exactly (4, 5, 7, 8… units while 4x is still at -20 %), it picks the
 * cheapest-for-BIES composition that is still >= -15 % for the customer.
 */

(function() {
  'use strict';

  // Full tier mapping: bundleCode → { 1..5: variantId }
  var BUNDLE_VARIANTS = {
    'PANCAKES': {
      1: '51754148004187',
      2: '51905117552987',
      3: '51905126531419',
      4: '51905132462427',
      5: '54265951355227'
    },
    'CAFE': {
      1: '51826441912667',
      2: '51905115423067',
      3: '51905123647835',
      4: '51905131413851',
      5: '54265952305499'
    },
    'PROT-CH': {
      1: '51392127500635',
      2: '51911578911067',
      3: '51905124434267',
      4: '51905131577691',
      5: '54265952338267'
    },
    'PROT-FR': {
      1: '51753624928603',
      2: '51905117127003',
      3: '51905125974363',
      4: '51905132101979',
      5: '54265952436571'
    },
    'BEB-MIX': {
      1: '50914720481627',
      2: '51905117782363',
      3: '51905128333659',
      4: '51905135346011',
      5: '54265952665947'
    },
    'BEB-TROP': {
      1: '50914696036699',
      2: '51905117978971',
      3: '51905128497499',
      4: '51905135509851',
      5: '54265952797019'
    },
    'BEB-CITR': {
      1: '50914690138459',
      2: '51905118306651',
      3: '51905128628571',
      4: '51905135673691',
      5: '54265952862555'
    },
    'BEB-LIM': {
      1: '50914686402907',
      2: '51905120174427',
      3: '51905128694107',
      4: '51905135804763',
      5: '54265952928091'
    },
    'BEB-MAND': {
      1: '50914677457243',
      2: '51905120960859',
      3: '51905129808219',
      4: '51905136001371',
      5: '54265952993627'
    },
    'BEB-DETOX': {
      1: '50914655404379',
      2: '51905121124699',
      3: '51905129939291',
      4: '51905136492891',
      5: '54265953059163'
    },
    'STEVIA': {
      1: '49746062967131',
      2: '51911577108827',
      3: '51905126760795',
      4: '51905132659035',
      5: '54265953124699'
    },
    'GRAN-CH': {
      1: '51155051053403',
      2: '51911578255707',
      3: '51905127285083',
      4: '51905133773147',
      5: '54265953157467'
    },
    'GRAN-OR': {
      1: '51834478166363',
      2: '51911578190171',
      3: '51905128202587',
      4: '51905134166363',
      5: '54265953223003'
    },
    'SHAKER': {
      1: '51386866663771',
      2: '51911578845531',
      3: '51905130398043',
      4: '51905136656731',
      5: '54265953288539'
    },
    'MATCHA': {
      1: '51991563043163',
      2: '52061009084763',
      3: '52061009117531',
      4: '52061009150299',
      5: '54265954435419'
    }
  };

  // Build reverse map: variantId (string) → { bundleCode, tier }
  var VARIANT_TO_BUNDLE = {};
  var codes = Object.keys(BUNDLE_VARIANTS);
  for (var c = 0; c < codes.length; c++) {
    var code = codes[c];
    var tiers = BUNDLE_VARIANTS[code];
    var tierKeys = Object.keys(tiers);
    for (var t = 0; t < tierKeys.length; t++) {
      var tier = parseInt(tierKeys[t], 10);
      var vid = String(tiers[tier]);
      VARIANT_TO_BUNDLE[vid] = { bundleCode: code, tier: tier };
    }
  }

  // Policy discount (what the product page promises) for a number of units.
  // 3 or more units = 15 %, with no cap.
  var POLICY_MIN_UNITS_FOR_MAX = 3;
  var POLICY_MAX_DISCOUNT = 15;
  function policyDiscount(units) {
    units = parseInt(units, 10) || 0;
    if (units >= POLICY_MIN_UNITS_FOR_MAX) return POLICY_MAX_DISCOUNT;
    if (units === 2) return 10;
    return 0;
  }

  // Policy view of each pack tier: every tier >= 3 is 15 %.
  var TIER_DISCOUNTS = { 1: 0, 2: 10, 3: 15, 4: 15, 5: 15 };

  // Day-D catalog prices represented by this preview. The live 4x catalog is
  // repriced at publication, never while this theme is only a draft.
  var CATALOG_TIER_DISCOUNTS = { 1: 0, 2: 10, 3: 15, 4: 15, 5: 15 };

  /**
   * Compose `units` of one bundle code from the pack variants that exist.
   * Rules, in order:
   *   1. units <= 2 (or a code without packs): a single line of that tier.
   *   2. units >= 3: any number of packs of tier >= 3 plus at most one small
   *      line (tier 1 or 2) for the remainder.
   *   3. Never charge more than the policy promises: the discount weighted
   *      by units must be >= policyDiscount(units).
   *   4. Among those, the smallest extra discount (closest to the promise),
   *      then the fewest lines.
   * Returns [{ tier, quantity, variantId }] sorted by tier desc, or [] if
   * the code is unknown.
   */
  function composeUnits(bundleCode, units) {
    var tiers = BUNDLE_VARIANTS[bundleCode];
    units = parseInt(units, 10) || 0;
    if (!tiers || units <= 0) return [];
    var tierNums = Object.keys(tiers).map(function(k) { return parseInt(k, 10); });
    var packTiers = tierNums.filter(function(t) { return t >= POLICY_MIN_UNITS_FOR_MAX; }).sort(function(a, b) { return b - a; });

    if (units < POLICY_MIN_UNITS_FOR_MAX || !packTiers.length) {
      if (tiers[units]) return [{ tier: units, quantity: 1, variantId: String(tiers[units]) }];
      return [{ tier: 1, quantity: units, variantId: String(tiers[1]) }];
    }

    var promise = policyDiscount(units) * units;   // in "unit-percent"
    var best = null;
    // Best composition that does NOT reach the promise, kept only as a fallback
    // when no composition can (e.g. a code missing its 5x): the highest
    // discount, then the fewest single units, then the fewest lines.
    var bestUnder = null;
    function consider(parts) {
      var weighted = 0, lines = 0, total = 0, singles = 0;
      Object.keys(parts).forEach(function(t) {
        var q = parts[t];
        if (!q) return;
        t = parseInt(t, 10);
        weighted += (CATALOG_TIER_DISCOUNTS[t] || 0) * t * q;
        total += t * q;
        lines += 1;
        if (t === 1) singles += q;
      });
      if (total !== units) return;
      var snapshot = function() { return JSON.parse(JSON.stringify(parts)); };
      if (weighted < promise) {
        if (!bestUnder || weighted > bestUnder.weighted ||
            (weighted === bestUnder.weighted && (singles < bestUnder.singles ||
              (singles === bestUnder.singles && lines < bestUnder.lines)))) {
          bestUnder = { weighted: weighted, singles: singles, lines: lines, parts: snapshot() };
        }
        return;
      }
      var excess = weighted - promise;
      if (!best || excess < best.excess ||
          (excess === best.excess && (singles < best.singles ||
            (singles === best.singles && lines < best.lines)))) {
        best = { excess: excess, singles: singles, lines: lines, parts: snapshot() };
      }
    }
    // Depth-first over pack tiers (desc); remainder must be 0, or a single small tier.
    function walk(i, remaining, parts) {
      if (i === packTiers.length) {
        if (remaining === 0) { consider(parts); return; }
        if (remaining < POLICY_MIN_UNITS_FOR_MAX && tiers[remaining]) {
          parts[remaining] = 1; consider(parts); delete parts[remaining];
        }
        return;
      }
      var t = packTiers[i];
      for (var q = Math.floor(remaining / t); q >= 0; q--) {
        if (q) parts[t] = q; else delete parts[t];
        walk(i + 1, remaining - t * q, parts);
      }
      delete parts[t];
    }
    walk(0, units, {});
    // No composition keeps the promise (only possible if a code lacks some
    // pack): use the closest one below it instead of N single units at full
    // price. The product page box shows max(policy, composed), so the price
    // shown still matches what the cart charges.
    if (!best) best = bestUnder;
    if (!best) {
      return [{ tier: 1, quantity: units, variantId: String(tiers[1]) }];
    }
    return Object.keys(best.parts).map(function(t) {
      t = parseInt(t, 10);
      return { tier: t, quantity: best.parts[t], variantId: String(tiers[t]) };
    }).sort(function(a, b) { return b.tier - a.tier; });
  }

  // Expose globals
  window.BIES_BUNDLE_VARIANTS = BUNDLE_VARIANTS;
  window.BIES_VARIANT_TO_BUNDLE = VARIANT_TO_BUNDLE;
  window.BIES_TIER_DISCOUNTS = TIER_DISCOUNTS;
  window.BIES_CATALOG_TIER_DISCOUNTS = CATALOG_TIER_DISCOUNTS;
  window.BIES_POLICY_DISCOUNT = policyDiscount;
  window.BIES_COMPOSE_UNITS = composeUnits;
  // Largest pack variant that exists. Not a cap on units any more: the cart
  // composes beyond it (BIES_COMPOSE_UNITS).
  window.BIES_MAX_TIER = Math.max.apply(null, Object.keys(BUNDLE_VARIANTS).map(function(code) {
    return Math.max.apply(null, Object.keys(BUNDLE_VARIANTS[code]).map(Number));
  }));
  window.BIES_MIN_TIER = 1;
  // Máximo de unidades por producto (Jaime, 7-oct): 1, 2, 3, 4 o 5. La ficha y
  // los +/− del carrito no dejan pasar de aquí.
  window.BIES_MAX_UNITS = 5;

})();
